<div class="condition-builder">
  <div class="condition-group" *ngFor="let group of groups; trackBy: trackGroup">
    <div class="condition-group-header">
      <h4>{{ 'Turbo.NotificationSettings.Meet' | translate : 'Meet' }} {{ group.Name }} {{ 'Turbo.NotificationSettings.AllConditionsTitle' | translate : 'of the following conditions' }}</h4>
      <button mat-stroked-button color="primary" type="button" (click)="addCondition(group.Id)">
        <mat-icon>add</mat-icon>{{ 'Turbo.NotificationSettings.Add' | translate : 'Add' }} {{ group.Name }} {{ 'Turbo.NotificationSettings.Condition' | translate : 'condition' }}
      </button>
    </div>

    <ng-container *ngFor="let condition of conditions; let conditionIndex = index; trackBy: trackCondition">
      <div *ngIf="condition.ConditionGroup === group.Id" class="condition-card">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Turbo.NotificationSettings.Field' | translate : 'Field' }}</mat-label>
          <mat-select [(ngModel)]="condition.Field" (selectionChange)="onFieldChanged(condition)">
            <mat-option *ngFor="let field of fields; trackBy: trackOption" [value]="field.Id">
              {{ field.Name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'Turbo.NotificationSettings.Operator' | translate : 'Operator' }}</mat-label>
          <mat-select [(ngModel)]="condition.Operator" (selectionChange)="onOperatorChanged(condition)">
            <mat-option *ngFor="let operator of getOperators(condition); trackBy: trackOption" [value]="operator.Id">
              {{ operator.Name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" *ngIf="getFieldValueType(condition.Field) === 'text'">
          <mat-label>{{ 'Turbo.NotificationSettings.Value' | translate : 'Value' }}</mat-label>
          <input matInput type="text" [(ngModel)]="condition.Value" (ngModelChange)="onValueChanged(condition)">
        </mat-form-field>

        <mat-form-field appearance="outline" *ngIf="getFieldValueType(condition.Field) === 'number'">
          <mat-label>{{ 'Turbo.NotificationSettings.Value' | translate : 'Value' }}</mat-label>
          <input matInput type="number" [(ngModel)]="condition.Value" (ngModelChange)="onValueChanged(condition)">
        </mat-form-field>

        <mat-form-field appearance="outline" *ngIf="getFieldValueType(condition.Field) === 'select'">
          <mat-label>{{ 'Turbo.NotificationSettings.Value' | translate : 'Value' }}</mat-label>
          <mat-select [(ngModel)]="condition.Value" (selectionChange)="onValueChanged(condition)">
            <mat-option *ngFor="let value of getFieldValues(condition); trackBy: trackOption" [value]="getOptionValue(value)">
              {{ value.Name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" *ngIf="getFieldValueType(condition.Field) === 'date'">
          <mat-label>{{ 'Turbo.NotificationSettings.Value' | translate : 'Value' }}</mat-label>
          <input matInput readonly [matDatepicker]="firstValueDatePicker" [value]="getDateModel(condition, 'Value')" (dateChange)="onDateChanged(condition, 'Value', $event.value)">
          <mat-datepicker-toggle matSuffix [for]="firstValueDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #firstValueDatePicker>
          </mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" *ngIf="getFieldValueType(condition.Field) === 'datetime'">
          <mat-label>{{ 'Turbo.NotificationSettings.Value' | translate : 'Value' }}</mat-label>
          <input matInput type="datetime-local" [ngModel]="condition.Value" (ngModelChange)="onDateTimeChanged(condition, 'Value', $event)">
        </mat-form-field>

        <mat-form-field appearance="outline" *ngIf="requiresSecondValue(condition.Operator) && getFieldValueType(condition.Field) === 'text'">
          <mat-label>{{ 'Turbo.NotificationSettings.Value2' | translate : 'Second value' }}</mat-label>
          <input matInput type="text" [(ngModel)]="condition.Value2" (ngModelChange)="updateCondition()">
        </mat-form-field>

        <mat-form-field appearance="outline" *ngIf="requiresSecondValue(condition.Operator) && getFieldValueType(condition.Field) === 'number'">
          <mat-label>{{ 'Turbo.NotificationSettings.Value2' | translate : 'Second value' }}</mat-label>
          <input matInput type="number" [(ngModel)]="condition.Value2" (ngModelChange)="updateCondition()">
        </mat-form-field>

        <mat-form-field appearance="outline" *ngIf="requiresSecondValue(condition.Operator) && getFieldValueType(condition.Field) === 'select'">
          <mat-label>{{ 'Turbo.NotificationSettings.Value2' | translate : 'Second value' }}</mat-label>
          <mat-select [(ngModel)]="condition.Value2" (selectionChange)="updateCondition()">
            <mat-option *ngFor="let value of getFieldValues(condition); trackBy: trackOption" [value]="getOptionValue(value)">
              {{ value.Name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" *ngIf="requiresSecondValue(condition.Operator) && getFieldValueType(condition.Field) === 'date'">
          <mat-label>{{ 'Turbo.NotificationSettings.Value2' | translate : 'Second value' }}</mat-label>
          <input matInput readonly [matDatepicker]="secondValueDatePicker" [value]="getDateModel(condition, 'Value2')" (dateChange)="onDateChanged(condition, 'Value2', $event.value)">
          <mat-datepicker-toggle matSuffix [for]="secondValueDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #secondValueDatePicker>
          </mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" *ngIf="requiresSecondValue(condition.Operator) && getFieldValueType(condition.Field) === 'datetime'">
          <mat-label>{{ 'Turbo.NotificationSettings.Value2' | translate : 'Second value' }}</mat-label>
          <input matInput type="datetime-local" [ngModel]="condition.Value2" (ngModelChange)="onDateTimeChanged(condition, 'Value2', $event)">
        </mat-form-field>

        <button mat-icon-button color="warn" type="button" aria-label="Remove condition" (click)="removeCondition(conditionIndex)"><mat-icon>close</mat-icon></button>
      </div>
    </ng-container>

    <div class="empty-group" *ngIf="!hasConditions(group.Id)">
      {{ 'Turbo.NotificationSettings.No' | translate : 'No' }} {{ group.Name }} {{ 'Turbo.NotificationSettings.ConditionsAdded' | translate : 'conditions added' }}
    </div>
  </div>
</div>
